import { Edit } from 'react-admin';
import { OrderForm } from './Order.Form';

export const OrderCreate = () => {
    return (
        <Edit>
            <OrderForm />
        </Edit>
    );
};
